export const API_URL = "https://wizardapidev.appgrowthcompany.com/";
export const MEDIA_UPLOAD = `https://wizardapidev.appgrowthcompany.com/media/upload/`;

// staging
// export const API_URL = "https://wizardstageapi.appgrowthcompany.com/";
// export const MEDIA_UPLOAD = `https://wizardstageapi.appgrowthcompany.com/media/upload/`;

export const GOOGLE_API_KEY = "AIzaSyAqZogUjdApPLRNXkJ4EUdcJPu9JceZ-rU";
// export const GOOGLE_API_KEY = "AIzaSyCES0pCZNW9kCYzWiq4g0oDvSjPQUAyLVY"; //Apptunix

export const END_POINTS = {
  login: "admin/login/",
  forgotPassword: "admin/forgot-password/",
  verifyOtp: "admin/verify-otp/",
  resendOtp: "admin/resend-otp/",
  resetPassword: "admin/reset-password/",
  changePassword: "admin/change-password/",
  logout: "admin/logout/",
  getProfile: "admin/admin-details/",
  updateProfile: "admin/update-profile/",

  // export csv
  exportCsv: "admin/csv-user/",

  // individuals
  individualListings: "admin/individual-user/",
  companyListings: "admin/company-user-details/",
  agentListings: "admin/agent-user-details/",
  deleteUser: "admin/user-delete-by-id/",
  changeUserStatus: "admin/user-disable-by/",
  userApproval: "admin/user-approve-reject-by/",
  getUserById: "admin/user-details-by/",
  updateUser: "admin/update-user-details-by/",
  addSalariedAgent: "admin/add-agent-user/",

  // User by id
  individualApplicationsById: "admin/user-applied-application-listing/",
  partnerApplicationsById: "admin/partner-application-listing/",

  // cms
  getCms: "common/get-cms/",
  updateCms: "admin/update-cms/",
  addFaq: "admin/add-faq/",
  getFaq: "admin/get-all-faq/",
  getFaqById: "admin/faq-detail/",
  updateFaq: "admin/faq-update/",
  deleteFaq: "admin/faq-delete/",

  //visa types
  getAllVisaTypes: "admin/get-all-visa-type/",
  visaTypeById: "admin/get-visa-type-details/",
  updateVisaType: "admin/update-visa-type/",

  // applications
  applicationListing: "admin/user-application-listing",
  applicationDetail: "admin/user-application-detail-by/",
  deleteApplication: "admin/delete-user-application-by/",
  updateApplication: "admin/user-application-detail-update-by/",
  applicationPayments: "admin/payment-application/",
  editApplication: "admin/application-update/",

  // country
  addCountry: "admin/add-country/",
  getAllCountries: "admin/get-all-country/",
  countryById: "admin/get-country-details/",
  countryStatus: "admin/update-country-status/",
  updateCountry: "admin/update-country/",
  deleteCountry: "admin/delete-country/",

  // citizenship
  addCitizenship: "admin/add-citizenship/",
  getAllCitizenships: "admin/get-all-citizenship/",
  citizenshipById: "admin/get-citizenship-details/",
  citizenshipStatus: "admin/update-citizenship-status/",
  updateCitizenship: "admin/update-citizenship/",
  deleteCitizenship: "admin/delete-citizenship/",

  // documents
  addDocument: "admin/add-doc-req/",
  getAllDocuments: "admin/get-all-doc-req/",
  documentById: "admin/doc-req-detail/",
  updateDocument: "admin/doc-req-update/",
  deleteDocument: "admin/doc-req-delete/",

  // salaries
  addSalaryStructure: "admin/add-salary-structure/",
  allSalaryStructures: "admin/get-all-salary-structure/",
  salaryStructureDetail: "admin/salary-structure-detail/",
  updateSalaryStructure: "admin/salary-structure-update/",
  deleteSalaryStructure: "admin/salary-structure-delete/",

  // paymentPlans
  addPaymentPlan: "admin/add-payment-plan/",
  updatePaymentPlan: "admin/update-payment-plan/",
  getPaymentPlans: "admin/get-all-payment-plan/",
  getPaymentPlanById: "admin/get-payment-plan-by/",
  deletePaymentPlan: "admin/delete-payment-plan/",

  //subamin-roles
  addRole: "admin/add-sub-role/",
  updateRole: "admin/update-role/",
  getAllRoles: "admin/get-all-sub-role/",
  deleteRole: "admin/delete-sub-role/",
  roleDetail: "admin/get-role/",

  // subadmin
  addSubadmin: "admin/add-sub-admin/",
  updateSubadmin: "admin/update-subadmin/",
  getSubadmins: "admin/get-all-subadmin/",
  getSubadminById: "admin/get-subadmin-by-id/",
  subadminStatusChange: "admin/update-subadmin-status-by-id/",
  deleteSubadmin: "admin/delete-subadmin/",

  // notifications
  addNotification: "admin/add-notification/",
  getNotifications: "admin/get-all-notifications/",
  deleteNotification: "admin/delete-notification/",
  getAdminNotification: "admin/notification-panel/",

  // counts
  companyCount: "admin/company-count/",
  agentCount: "admin/agent-count/",
  applicationCount: "admin/application-count/",

  // customer support
  getQueries: "admin/get-all-queries/",
  deleteQuery: "admin/delete-query-by/",
  revertQuery: "admin/revert-query-by/",
  queryById: "admin/get-query-by/",

  // commission
  agentCommissionById: "admin/agent-benefits/",

  // payment modes
  addPaymentMode: "admin/add-payment-mode/",
  getAllpaymentModes: "admin/get-all-payment-mode/",
  paymentModeById: "admin/get-payment-mode-by/",
  updatePaymentMode: "admin/update-payment-mode/",
  deletePaymentMode: "admin/delete-payment-mode/",

  // payments
  getAllPayments: "admin/payment/",
  paymentById: "admin/payment/",
  deletePayment: "admin/payment-delete/",
  paymentStatus: "admin/payment-status/",
  exportPayments: "admin/csv-payments/",

  agentRevenue: "admin/agent-revenue/",
  salariedAgentPayments: "admin/payment-salary-agent/",
  userPayments: "admin/payment-user/",
  partnerPayments: "admin/payment-partner/",

  // graph  // dashboard
  dashboard: "admin/dashboard/",

  userGraph: "admin/user-graph/",
  applicationGraph: "admin/application-graph/",
  revenueGraph: "admin/revenue-graph/",

  // exportCsv
  userExportCSV: "admin/csv-user-count/",
  applicationExportCSV: "admin/csv-application-count/",
  revenueExportCSV: "admin/csv-payment-revenue/",
  exportApplications: "admin/csv-applications/",

  // face check image
  faceCheck: "media/face-check/",
  passportCheck: "media/passport/",
  documentCheck: "media/document-check/",

  // religion
  addReligion: "admin/add-religion/",
  getAllReligion: "admin/get-all-religion/",
  getReligionDetails: "admin/get-religion-details/",
  changeReligionStatus: "admin/update-religion-status/",
  updateReligion: "admin/update-religion/",
  deleteReligion: "admin/delete-religion/",

  // Offer Letter
  minPaymentUsers: "admin/payment-min/",
  sendOfferLetter: "admin/offer-letter/",
};
